import { BaseModel } from './base.model'
import { Team } from './team.model'
import { Vehicle } from './vehicle.model'

export class Depot extends BaseModel {
  id: string
  name: string
  team: Team
  createdAt: string
  vehicles: Vehicle[]
  vehiclesCount: number
  color: string
}

export type DepotInList = Pick<Depot, 'id' | 'name'>
